<template>
  <div id="privacyAgreement">
    <div class="head">泛生子产品/服务隐私政策</div>
    <div class="date">生效日期：【2022】年【10】月【20】日</div>
    <div class="title">引言</div>
    <div class="p">
      <span>北京泛生子基因科技有限公司（简称“我们”或“泛生子”）</span>
      深知个人信息对您的重要性，并将严格遵守法律法规、参照行业实践来保护您的个人信息。为此，我们制定了《泛生子产品/服务隐私政策》（简称“本政策”），详细地介绍了以下内容
    </div>
    <div class="p">
      在开始使用我们的产品/服务和/或提供产品/服务所必需的泛生子运营的线上平台——泛生子<span>BRAVE</span>（简称）<span>“Brave”</span>前，请您务必仔细阅读并充分理解本政策，<span>特别是以粗体标识的条款，</span>并决定是否同意我们据此处理您的个人信息。<span
        >请您注意，如果您不同意本政策，将会影响您使用我们的产品/服务。在法律允许的情况下，我们可以不基于您的同意而收集、使用您的个人信息。在法律要求的情况下，我们将会就处理个人信息的特定情形征求您的单独同意。</span
      >
      <span
        >请您注意，本政策仅适用于泛生子依据您与泛生子之间签署的特定的产品/服务合同（简称“合同”）为您提供的产品/服务，以及线上平台Brave，不论产品/服务经由线上平台Brave或以任何其他方式提供。</span
      >对于我们提供的合同之外的任何产品/服务，或对于与<span>Brave</span>存在接入、业务合作、广告展示等关系的任何第三方的产品/服务，本政策并不适用，<span
        >请您阅读相应的产品、服务、及第三方的隐私政策，我们不对第三方的个人信息处理活动承担任何法律责任。</span
      >
      如果您对本政策有任何疑问或建议，您可以通过“联系我们”中所提供的方式与我们联系。
    </div>
    <div class="title">一、个人信息的收集与使用</div>
    <div class="p">
      在您使用我们的产品/服务时，我们可能收集、使用的您的个人信息。<span>如果您在使用过程中向我们提供他人的个人信息，请您确保他人对该等情况充分知情、并予以同意（如适用），且您的该等行为不侵犯任何人的合法权益。</span>具体而言，我们为您提供如下功能，各个功能涉及的处理目的、个人信息类型<span
        >（其中的敏感个人信息已加粗显示，请您特别注意）</span
      >
      如下所示。
    </div>
    <div class="titleTwo">(一)合同签署及履行</div>
    <div class="p">
      为履行合同所必需，为了向您提供产品/服务，您需要至少向我们提供您的身份证件信息、电话号码、电子邮箱等个人信息，以及向我们提供您的既往诊断信息，包括但不限于
      <span>治疗史、家族史、病理报告、随访信息、</span
      >等个人健康信息。如果您拒绝提供上述信息，将导致我们无法提供全部或部分产品/服务。
      如发生退款，您可能还需要向我们提供您的<span>银行账户信息</span>。如果您拒绝提供上述信息，将可能导致我们无法完成向您退款。
    </div>
    <div class="titleTwo">(二)账户注册及管理</div>
    <div class="p">
      为了创建<span>Brave</span>账户，您需要至少向我们提供您的手机号码，通过获取验证码或设置密码登录。如果您拒绝提供上述信息，您将无法正常使用我们的<span>Brave</span>账户服务。您也可选择通过微信登录，我们将获取您的微信账号和头像。
    </div>
    <!-- <div class="titleTwo">(二)患者信息管理</div>
    <div class="p">
      为了让您更便捷地管理个人健康信息，您可以自主选择上传<span>治疗史、家族史、病理报告、随访信息、暴露史</span>等个人健康信息。如果您拒绝提供上述信息，您将无法使用相关患者信息管理功能，但不影响您正常使用其他功能。
    </div> -->
    <div class="titleTwo">(三)为您提供安全保障</div>
    <div class="p">
      为了保障您正常使用我们的产品/服务、保障您的
      <span>Brave</span> 账户安全，在您使用
      <span>Brave</span
      >过程中，我们需要收集、使用您的账号信息、设备信息和<span>日志信息</span>用于判断账户安全、进行身份验证、识别违法违规情况、检测及防范安全事件、维护系统安全、维护产品/服务的正常运行。
    </div>
    <div class="titleTwo">(四)基于设备权限的功能</div>
    <div class="p">
      在使用
      <span>Brave</span
      >时，为进一步提升您的使用体验，我们可能向您请求开启不同的设备权限，从而收集、处理相应的个人信息。如果您拒绝开启某个设备权限，您将无法使用与之对应的功能，但不影响您正常使用其他功能。您可以随时通过您手机或其他设备的系统权限管理页面，修改与<span>Brave</span>相关的设备权限。
    </div>
    <div class="p">
      设备权限列表详见附件，进一步了解各个权限的名称、使用目的、调用情况说明
    </div>
    <div class="titleTwo">(五)Cookie和同类技术的使用</div>
    <div class="p">
      Cookie是互联网中普遍使用的技术，在您使用我们的产品/服务时，为优化您的访问体验并保障产品/服务正常高效运转，我们可能会在您的设备上存储一个或多个名为Cookie的小型文件。我们可能使用Cookie简化您的登录流程、判断您的使用环境安全状态、帮助您优化对广告的选择与互动、保护您的数据安全等。您可以自行管理或删除计算机或移动设备上所储存的Cookie。大多数浏览器会自动接收Cookie，但您通常可以根据自己的需要更改浏览器的Cookie设置。
    </div>
    <div class="titleTwo">(六)无需您同意的收集、使用、处理</div>
    <div class="p">
      <span
        >请您注意，根据法律法规的规定，在以下情形中，我们无需取得您的同意即可收集、使用或以其他方式处理您的个人信息：</span
      >
      <br />
      1.
      为订立、履行个人作为一方当事人的合同所必需，或者按照依法制定的劳动规章制度和依法签订的集体合同实施人力资源管理所必需；
      <br />
      2. 为履行法定职责或者法定义务所必需；
      <br />
      3.
      为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；
      <br />
      4. 为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；
      <br />
      5.
      依照适用法律规定在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；
      <br />
      6. 法律、行政法规规定的其他情形。
      <span
        >匿名化处理后的信息不再属于个人信息，因此不受本政策的约束和保护。</span
      >
    </div>
    <div class="title">二、 个人信息的共享、转让、公开披露</div>
    <div class="p">
      我们高度重视保护您的个人信息，仅在取得您的同意或法律法规允许的情况下，才会共享、转让、公开披露您的个人信息。
    </div>
    <div class="titleTwo">(一)共享</div>
    <div class="p">
      <span class="titleThree">1. 与泛生子关联公司共享</span>
      <div class="p">
        为履行与您之间的合同、向您提供产品与服务，
        <span>我们可能与关联公司共享您必要的个人信息，</span
        >以便联合向您提供您所要求的产品或服务。
        <br />
        关联公司是指北京泛生子基因科技有限公司通过股权、协议或其他方式直接或间接控制、被控制或共同控制的公司，包括但不限于北京泛生子医学检验实验室有限公司、重庆泛生子生物科技有限公司、重庆今创泛生医学检验实验室有限公司和无锡泛生子生物科技有限公司（该关联公司可能不时更新）。
        <br />在共享您的个人信息之前以及共享的过程中，我们将充分评估该等共享的合法性、正当性、必要性，并采用适当的管理措施与技术措施，以保障您的个人信息安全。关联公司如果想要改变本隐私政策声明的个人信息使用目的，将再次征求您的授权同意。
        <br />
      </div>
      <span class="titleThree">2.与第三方合作伙伴共享</span>
      <div class="p">
        <span
          >为了更好地为您提供产品/服务，我们与第三方合作伙伴进行业务合作，并在实现业务合作的必要合理范围内共享您的个人信息。</span
        >
        <br />
        <span>保障运行安全：</span
        >我们可能与安全服务提供商共享您的设备信息、网络信息、<span>日志信息</span>，以综合判断您的账号风险、预防安全事件、保障我们产品/服务的安全运行。
        <br />
        <span>统计、优化服务：</span
        >我们可能与运营服务提供商共享您的设备信息、<span>日志信息、</span>网络信息，以快速发现并解决异常、分析故障的产生原因、改善产品/服务的使用体验、掌握产品运营动态、及时跟进用户反馈。
        <br />
      </div>
      <span class="titleThree">3.通过SDK共享</span>
      <p>
        为了更好地向您提供产品与服务，在您使用<span>Brave</span>时，我们会通过软件开发工具包（<span>SDK</span>）、应用程序接口（<span>API</span>）等方式进行必要的数据共享。我们会对接入的<span>SDK、API</span>进行安全监测，并要求其采取数据保护措施。
      </p>
      <p>
        您可查看下方<span>SDK</span>列表，进一步了解<span>SDK</span>的名称、运营方、使用目的、个人信息的类型等具体情况。
      </p>
    </div>

    <img src="../../assets/隐私协议.png" />
    <div class="p">
      <span>SDK</span>名称：极光推送<span>SDK</span><br />
      服务类型：消息推送服务<br />
      <span>SDK</span>收集个人信息类型：<br />
      设备信息（<span>IMEI/MAC/AndroidID/IDFA/OAID/OpenUDID/GUID/SIM</span>卡<span>IMSI/获取传感器</span>信息等）：用于识别唯一用户，保证消息推送的精准送达；优化推送通道资源，我们会根据设备上不同APP的活跃情况，整合消息推送的通道资源，为开发者提高消息送达率；为开发者提供智能标签以及展示业务统计信息的服务；
      网络信息与位置信息（IP地址，WiFi信息，基站信息等相关信息）：优化
      <span>SDK</span>
      与极光服务器的网络连接请求，保证服务的稳定性和连续性；实现区域推送的功能。
      APP
      安装列表信息：当一个设备有多个APP的推送链路同时活跃时，我们采用合并链路技术，随机合并成一条链路，以达到为用户节省电省流量的目的。<br />
      极光隐私权政策链接：<a href="https://www.jiguang.cn/license/privacy"
        >https://www.jiguang.cn/license/privacy</a
      >
    </div>
    <div class="p">
      <span>SDK</span>名称：友盟<span>SDK</span><br />

      服务类型：社会化分享、智能认证<br />
      收集个人信息类型：设备信息（<span>IMEI/MAC/AndroidID/IDFA/OpenUDID/GUID/SIM卡IMSI/IP/地理位置</span>）、应用列表、获取设备序列号<br />
      隐私权政策链接：<a href="https://www.umeng.com/page/policy"
        >https://www.umeng.com/page/policy</a
      >
    </div>
    <!-- <table>
      <thead>
        <tr>
          <td>名称</td>
          <td>运营方</td>
          <td>使用目的</td>
          <td>个人信息类型</td>
          <td>隐私政策/官网链接</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>分享智能认证</td>
          <td>友盟认证SDK</td>
          <td>社会化分享U-Share，智能认证U-Verify</td>
          <td>用于用户QQ,微信分享，登录，以及手机号一键登录</td>
          <td>https://www.umeng.com/page/policy</td>
        </tr>
        <tr>
          <td>消息推送SDK</td>
          <td>极光认证SDK</td>
          <td>用于实现App一键登录，号码认证的功能</td>
          <td>设备信息、位置信息、网络信息、SDK认证相关请求结果、手机号码</td>
          <td>https://www.jiguang.cn/license/privacy</td>
        </tr>
      </tbody>
    </table> -->
    <div class="titleTwo">(二)转让</div>
    <div class="p">
      <span
        >如果我们因合并、分立、解散、被宣告破产等原因需要转移您的个人信息，我们会向您告知接收方的名称或者姓名和联系方式，并要求接收方继续受本政策的约束。</span
      >接受方如果变更原先的处理目的、处理方式，将依法重新征求您的同意，除非法律法规另有规定。在破产清算且无接收方的情形下，我们将删除您的个人信息，除非法律法规另有规定。
    </div>
    <div class="titleTwo">(三)公开披露</div>
    <div class="p">
      我们一般不会公开披露您的信息，除非取得您的单独同意，或依据法律法规的相关要求。
    </div>
    <div class="p">
      请注意，您在使用我们的产品/服务的过程中可能会自行公开的一些信息，其中可能涉及您的个人信息甚至敏感个人信息，请您谨慎考虑是否公开上述信息。如果涉及他人的个人信息，您可能需要征得他人的同意（如适用）。
    </div>
    <div class="titleTwo">(四)无需您同意的共享、转让、公开披露</div>
    <div class="p">
      <span
        >请您注意，根据法律法规的规定，在以下情形中，我们无需取得您的同意即可共享、转让、公开披露您的个人信息：</span
      >
      <p>
        1.
        为订立、履行个人作为一方当事人的合同所必需，或者按照依法制定的劳动规章制度和依法签订的集体合同实施人力资源管理所必需；
      </p>
      <p>2. 为履行法定职责或者法定义务所必需；</p>
      <p>
        3.
        为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；
      </p>
      <p>
        4. 为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；
      </p>
      <p>
        5.
        依照适用法律规定在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；
      </p>
      <p>6. 法律、行政法规规定的其他情形。</p>
      <span
        >匿名化处理后的信息不再属于个人信息，因此不受本政策的约束和保护。</span
      >
    </div>
    <div class="title">三、个人信息的安全保障</div>
    <div class="p">
      我们高度重视您的个人信息安全，并采取符合法律法规、业界标准、合理可行的各类安全措施，保护您的个人信息，防止发生个人信息的泄露、损毁、丢失、篡改等安全事件。
      <p>
        <span>1.管理措施：</span
        >我们建立了个人信息安全相关的公司制度、组织机构与管理人员。我们严格限制有权访问个人信息的人员范围，要求他们遵守保密义务。我们还会举办个人信息保护与安全的培训课程，加强员工对个人信息保护的意识与能力。
      </p>
      <p>
        <span>2.技术措施：</span>
        我们会使用加密技术提高个人信息的安全性，您的<span>Brave</span>账户与服务器之间的数据交换可能受<span>SSL</span>协议加密保护。我们使用受信赖的保护机制防止个人信息遭到恶意攻击。
      </p>
      <p>
        <span>3.安全事件应对：</span>
        我们制定了个人信息安全事件应急预案，并注意风险的监测与预防。若不幸发生或可能发生个人信息泄露、篡改、丢失等安全事件，我们会立即启动应急预案、采取补救措施，尽力降低安全事件的影响。我们将通过邮件、推送、公告等合理、有效的方式，依法告知您安全事件的原因、危害、个人信息的类型、补救措施等事项。我们还将依法向有关监管机构上报安全事件的相关情况。
      </p>
      <p>
        <span>4.请您共同防范安全风险：</span>
        我们将尽力确保您在使用我们的产品/服务过程中的信息安全，但请您理解，互联网环境并非绝对安全的环境。请您妥善保管您的账号及密码，并尽量使用复杂密码，共同维护您的账户及个人信息的安全。
      </p>
    </div>
    <div class="title">四、个人信息的存储期限与地点</div>
    <div class="titleTwo">(一)存储期限</div>
    <div class="p">
      <span
        >一般而言，我们只会在实现处理目的所必需的期限内保留您的个人信息，除非法律法规另有规定。</span
      >我们判断个人信息的存储期限主要依据以下标准，例如：
    </div>
    <div class="p">
      <p>
        1.
        对于您创建的账户：我们将保存您在该账户下的个人信息，直至您注销账户后的合理期限；
      </p>
      <p>
        2.
        如果法律法规另有规定，或者我们和您另有约定，则以该等规定或约定的存储期限为准。
      </p>
      <p>
        在超出存储期限后，我们会依法删除或匿名化处理您的个人信息。如果删除从技术上难以实现的，我们会停止除存储和采取必要的安全保护措施之外的处理活动。
      </p>
      <p>
        如您是<span>Brave</span>用户，在我们停止运营<span>Brave</span>
        G时，我们将提前30天通知您，停止相关的个人信息收集活动，并在合理的期限内删除或匿名化处理您的个人信息。
      </p>
    </div>
    <div class="titleTwo">(二)存储地点</div>
    <div class="p">
      我们会将在中华人民共和国（简称<span>“中国”</span>）境内收集和产生的个人信息存储在中国境内。
      <p>
        如果今后涉及个人信息的出境（例如，存储地点从中国境内转移到中国境外），届时我们将严格依照法律法规的规定，落实个人信息出境的要求与条件。
      </p>
    </div>
    <div class="title">五、您对个人信息的权利与选择</div>
    <div class="p">
      您可以通过以下方式查阅和管理您的信息，我们会在符合法律法规要求的情形下充分尊重您对个人信息的权利和选择，并响应您的请求。
    </div>
    <div class="titleTwo">(一)查阅、更正和补充</div>
    <div class="p">
      <span>您有权通过以下方式查阅、更正和补充您的个人信息：</span>
      <p>1. 登录<span>Brave</span>账户查阅、更正和补充您的部分个人信息；</p>
      <p>
        2.
        通过“联系我们”中所提供的方式向我们提出请求，查阅、更正和补充您的其他个人信息。
      </p>
    </div>
    <div class="titleTwo">(二) 注销账号</div>
    <div class="p">
      你可以通过访问Brave“我的”页面上方“账号安全”-“账号注销”中进行在线操作。
      <span
        >您注销成功后，除法律法规及相应的国家标准另有规定外，我们将删除您的个人信息或作匿名化处理。</span
      >
    </div>
    <div class="titleTwo">(三)其他请求</div>
    <div class="p">
      <span
        >在符合法律法规的情形下，您还可以通过“联系我们”中所提供的方式向我们提出下列请求：
      </span>
      <p>1. 复制我们所存储的您的个人信息；</p>
      <p>
        2. 改变或者撤回您授权我们收集、处理您的个人信息的范围。<span
          >请您注意，删除权的行使并非绝对的，仅在法定情形下，您有权请求我们删除您的个人信息。此外，出于保存期限的法定要求或技术上的限制，我们可能难以删除您的个人信息，但我们会停止除存储和采取必要的安全保护措施之外的处理活动。</span
        >
      </p>
      <p>
        3. 请求我们删除您的个人信息。
        <span
          >请您注意，删除权的行使并非绝对的，仅在法定情形下，您有权请求我们删除您的个人信息。此外，出于保存期限的法定要求或技术上的限制，我们可能难以删除您的个人信息，但我们会停止除存储和采取必要的安全保护措施之外的处理活动。</span
        >
      </p>
      <p>
        4. 申请注销您的<span>Brave</span>账户。<span
          >请您注意，在账户注销之后，您可能无法使用Brave中全部或部分的功能或服务，并且，我们将在合理期限内删除您的个人信息。</span
        >
      </p>
    </div>
    <div class="titleTwo">(四)已故用户的个人信息保护</div>
    <div class="p">
      如果我们的用户不幸逝世，您作为近亲属，为了自身的合法、正当利益，您可以依法对逝者的相关个人信息行使查阅、复制、更正、删除等权利，除非逝者生前另有安排。请通过“联系我们”中所提供的方式向我们提出请求。为了保护逝者的个人信息，我们需要您协助提交相应的证明文件。
    </div>
    <div class="titleTwo">(五)响应您的请求</div>
    <div class="p">
      <p>我们充分尊重您的个人信息权利，并全力响应您的行权请求。</p>
      <p>
        请您注意，对于您的合理请求，我们原则上不收取费用。对于多次、重复、超出合理限度的请求，我们可能酌情收取一定费用。如果您的请求包含不属于您的个人信息、超出合理限度、需要过多技术手段（如需要开发新系统或从根本上改变现行惯例）、可能侵害他人合法权益、不切实际，或者我们存在合法、正当的其他理由，我们可能拒绝响应您的请求，并向您说明理由。
      </p>
      <p>我们将尽快处理您的请求，并在验证您的身份后的15日内予以回复。</p>
      <p>
        如果您对我们的回复不满意，特别是您认为我们的个人信息处理活动损害了您的合法权益，您可以依法向监管机构投诉或向法院提起诉讼。
      </p>
    </div>
    <div class="title">六、未成年人的保护</div>
    <div class="p">
      <p>
        我们高度重视对未成年人个人信息的保护。我们的产品/服务以及<span>Brave</span>（如适用）主要面向成年人。如果您是18周岁以下的未成年人，在使用我们的产品/服务以及<span>Brave</span>（如适用）前，您应在您的父母或其他监护人的陪同下阅读并同意本政策。
      </p>
      <p>
        如果我们发现我们在未取得其父母或其他监护人的同意的情况下，收集了14周岁以下的未成年人的个人信息，我们将及时删除相关的个人信息。
      </p>
    </div>
    <div class="title">七、隐私政策的更新</div>
    <div class="p">
      随着我们的业务、产品与服务的完善与变化，本政策也可能随之变更。我们将在<span>Brave</span>中发布本政策的更新版本，
      <span>对于本政策的重大变更，我们将会以更显著的方式通知您，</span
      >例如，弹窗、推送、公告、邮件、或其他符合法律要求的适当形式。
      <span
        >未经您的知情和同意（如适用），我们不会削减您按照本政策所享有的权利。</span
      >
    </div>
    <div class="p">
      本政策所指的重大变更包括但不限于：
      <p>
        1.我们的业务、产品或服务的模式发生重大变化，影响到个人信息的处理目的、处理方式、处理的个人信息种类；
      </p>
      <p>
        2.我们在所有权结构、组织架构等方面发生重大变化，导致处理个人信息的主体发生变化；
      </p>
      <p>3.个人信息共享、转让、公开披露的主要对象发生变化；</p>
      <p>4.您行使个人信息权利的方式和程序发生重大变化；</p>
      <p>5.我们的个人信息保护团队、个人信息保护负责人的联系方式发生变化；</p>
      <p>6.我们的个人信息保护影响评估提示存在高风险；</p>
      <p>7.其他可能对您的个人权益有重大影响的情形。</p>
    </div>
    <div class="title">八、联系我们</div>
    <div class="p">
      <p>
        我们设立了专门的个人信息保护团队和个人信息保护负责人，您可以通过以下方式与我们联系：
      </p>
      <p>
        1.
        您可以使用<span>Brave</span>中的客服功能，操作路径为：我的-关于<span>BRAVE</span>-联系我们；
      </p>
      <!-- <p>2.您可以发邮件至： galileo@genetronhealth.com；</p> -->
      <p>2. 您可以拨打电话：400-099-6336。</p>
    </div>
    <br />
    <br />
    <br />
    <div class="p" style="paddingBottom:20px">
      <p>附件：</p>
      <p>Android和IOS操作系统应用权限：</p>
      <!-- <p>（1）拍摄照片和录制视频（录入“病理报告”的时候需要拍照上传照片）</p>
      <p>
        （2）访问设备照片，媒体文件和文件（录入“病理报告”的时候需要访问本机相册，以及本机的PDF文件）
      </p> -->
      <!-- <p>
        （1）获取设备信息（需要通网络状态去判断页面显示内容，比如“暂无网络，点击重试”）
      </p>
      <p>
        （2）允许接受通知权限（您有新的报告时，会以状态栏消息的形式发送通知）
      </p> -->
      <p>（1）拍摄照片和录制视频（录入”病理报告“的时候需要拍照上传照片）</p>
      <p>
        （2）访问设备照片，媒体文件和文件（录入”病理报告“的时候需要访问本机相册，以及本机的PDF文件）
      </p>
      <p>
        （3）获取设备信息（需要通网络状态去判断页面显示内容，比如”暂无网络，点击重试“）
      </p>
      <p>
        （4）允许接受通知权限（患者有新的报告时，会以状态栏消息的形式发送通知）
      </p>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
#privacyAgreement {
  height: 100vh;
  padding: 20px 23px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
.head {
  width: 100%;
  //   height: 30px;
  font-size: 22px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 700;
  color: #2f354d;
  line-height: 30px;
  margin-bottom: 6px;
}
.date {
  width: 100%;
  //   height: 24px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #9095a7;
  line-height: 24px;
}
.title {
  width: 100%;
  //   height: 22px;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: #2f354d;
  line-height: 22px;
  padding-top: 40px;
  padding-bottom: 20px;
}
.titleTwo {
  width: 100%;
  //   height: 24px;
  font-size: 15px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: #2f354d;
  line-height: 24px;
  margin-bottom: 20px;
}
.titleThree {
  display: block;
  width: 100%;
  //   height: 24px;
  font-size: 15px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: #2f354d;
  line-height: 24px;
  margin-bottom: 20px;
}

.p {
  width: 100%;
  //   height: 144px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #5f697d;
  line-height: 24px;
  margin-bottom: 20px;
  span {
    font-weight: bold;
  }
}
table {
  margin-bottom: 20px;
  width: 100%;
  box-sizing: content-box;
  thead,
  tbody {
    width: 100%;
    tr {
      border: 1px solid #9d9d9d;
      border-left: none;
      td {
        //   min-width: 40px;
        width: 12.5%;
        border-left: 1px solid #9d9d9d;
        padding: 2px;
      }
    }
  }
  thead {
    margin-bottom: -1px;
    background: #d8d8d8;
  }
}
img {
  width: 100%;
  margin-bottom: 20px;
  height: 170px;
}
</style>
